import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { Row } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var ChoiceOptionRowContainer = function ChoiceOptionRowContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Row, _extends({
    justifyContent: "center",
    ml: -4
  }, props), children);
};
ChoiceOptionRowContainer.propTypes = {
  children: PropTypes.node
};
ChoiceOptionRowContainer.defaultProps = {
  children: null
};
export { ChoiceOptionRowContainer as default };